import { QueryFeature } from '../../../config/queryClient';

export enum QueryKey {
  ExcessCash = 'ExcessCash',
  ExcessCashOptions = 'ExcessCashOptions',
}

export const queryKeys = {
  manageExcessCash: (clientId: string) => [QueryKey.ExcessCash, clientId],
  getExcessCashOptions: (isConsumer: boolean, page?: string) => [
    QueryFeature.Settings,
    QueryKey.ExcessCashOptions,
    isConsumer,
    page,
  ],
};
